import type { ErrorResponse } from '@repo/contracts';
import { AxiosError } from 'axios';

/** The gateway's id for the request, to quote when something fails. Body and header carry the same value. */
export const requestIdOf = (error: unknown): string | null => {
  if (!(error instanceof AxiosError)) return null;

  const fromBody = (error.response?.data as ErrorResponse | undefined)?.requestId;
  const fromHeader = error.response?.headers?.['x-request-id'];

  return fromBody ?? (typeof fromHeader === 'string' ? fromHeader : null);
};
